/* dajo-compromiso.js, 19 sep 2026: los scripts de la landing y del cotizador, antes inline (42 KB); carga con defer */

/* =========================================================================
   PRECIOS  ·  editar aquí y nada más (todo en pesos, IVA incluido)
   Base: cotización real COT-2026-104 (marquesa 1.53 ct 14k = $31,997)
   y la plantilla de compromiso (oro 14k 3.8 g = $7,600 metal + $5,800 mano de obra)
   ========================================================================= */
var P = {
  montura:      { plata:1500, oro10:10100, oro14:13700, oro10b:10100, oro14b:13700 },   /* 18 sep: auditoria, costo x1.8 (Jorge: "ajustalo a estos nuevos precios") */   /* Jorge 7 sep 2026: plata 1500, 10k 9500, 14k 13000, blanco = amarillo */   // anillo con piedra central: metal + diseño 3D + cera + fabricación
  monturaBanda: { plata:2500, oro10:6000,  oro14:7500, oro10b:6500, oro14b:8100 },    // churumbela o eternity, sin piedra central
  engasteCentral: 3500,   /* 18 sep: antes 1500 = costo, no pagaba cargas */                                     // colocar la piedra del centro
  multEngarce:  { garras:1, catedral:1.10, bisel:1.10, halo:1.20, halooculto:1.15,
                  pave:1.15, trespiedras:1.15,  canal:1.15, twist:1.20, arodividido:1.20, eternity:1 },
  piedritas:    { garras:0, catedral:0, bisel:0, halo:20 /* 14 sep: Jorge, halo similar a pave o arriba; antes 16 y salia $1,750 abajo */, halooculto:14, pave:20,
                  trespiedras:0,  canal:9, twist:10, arodividido:12, eternity:30 },
  mmPiedrita:   { halo:1.3, halooculto:1.3, pave:1.5, canal:2, twist:1.5, arodividido:1.5, eternity:2 },   /* 19 sep: tamaño de la piedrita según la montura */
  precioPiedrita:{ /* 19 sep: por piedra y por mm. KRONO (18 sep) × 1.35 + $35 de engaste, × 1.8 (la misma regla que la piedra central). Zirconia = Jorge 7 sep */
    zirconia:  { "1.3":80,  "1.5":80,  "2":80 },
    moissanita:{ "1.3":100, "1.5":105, "2":150 },    /* MST-027 $15 · MST-018 $18 · MST-008 $35 */
    diamante:  { "1.3":145, "1.5":185, "2":255 },    /* DLA-008 $33 · DLA-007 $50 · DLA-005 $80 (E-F VS1) */
    natural:   { "1.3":390, "1.5":525, "2":840 }     /* DMT-047 $135 · DMT-045 $190 · 2 mm no hay: DMT-085 1.75 mm $320 (F-G VS2) */
  },
  central: {
    zirconia:  { "0.5":350,  "0.75":420,  "1":500,   "1.5":700,   "2":900 },
    moissanita:{ "0.5":2400, "0.75":3200, "1":4200,  "1.5":6200,  "2":8500 },
    diamante:  { "0.5":10000, "0.75":12200, "1":14400, "1.5":22100, "2":32500 },   /* 18 sep: costo Krono x1.8; 0.75 interpolado */   /* Hera Haus, sueltos G-H VS, sep 2026 */
    natural:   { "0.5":25000, "0.75":55000, "1":85000, "1.5":140000, "2":190000 }   /* Jorge 7 sep */  /* de mina G-H VS aprox, Hera Haus sep 2026 */
  },
  multForma:   { redondo:1.15, ovalo:0.95, princesa:0.85, esmeralda:0.85, cojin:0.90, pera:0.95,
                 marquesa:0.95, radiante:0.90, asscher:0.85, corazon:1.00, baguette:0.80 },
  multCalidad: { alta:1.15, media:1.00, entrada:0.85 },     // solo aplica a diamante
  msi: 9,   /* Jorge 7 sep: 9 MSI */
  oroPorQuilate: 0.06,                                     // +6% de montura por cada quilate arriba de 1 ct (0.5 ct = -3%, 2 ct = +6%)
  holgura: 0.08                                             // el rango que se muestra, +/- 8%
};
var WA = "https://wa.me/5213314679674";

var NOMBRE = {
  eternity:"eternity",
  zirconia:"zirconia", moissanita:"moissanita", diamante:"diamante de laboratorio", natural:"diamante natural",
  redondo:"redondo", ovalo:"óvalo", princesa:"princesa", esmeralda:"esmeralda", cojin:"cojín", pera:"pera",
  marquesa:"marquesa", radiante:"radiante", asscher:"asscher", corazon:"corazón", baguette:"baguette",
  garras:"solitario", catedral:"catedral", bisel:"bisel", halo:"halo", halooculto:"halo oculto", pave:"pavé",
  trespiedras:"tres piedras",  canal:"canal", twist:"trenzado", arodividido:"aro dividido",
  plata:"plata .925", oro10:"oro amarillo 10k", oro14:"oro amarillo 14k", oro10b:"oro blanco 10k", oro14b:"oro blanco 14k",
  /* las etiquetas de calidad se quitaron el 13 sep: nombrar una letra le da al cliente derecho a pedirla al precio de la letra (Jorge, 12 sep). Si vuelve el paso de calidad, las etiquetas van sin letras. */
};

var sel = { material:"diamante", forma:"redondo", quilates:"1", calidad:"media", engarce:"garras", metal:"oro14" };

/* cotizador:v4 */
/* 5 pasos, 19 botones. La piedra volvio a ser paso el 9 sep por peticion de
   Jorge ("mete imagenes aqui y hazlo parte de los pasos"), asi que se quito el
   interruptor: preguntar lo mismo en dos lugares confunde mas que ayudar.
   Los precios de TODO lo que no se pregunta siguen vivos en P. */
var GEMA = {"zirconia": "<svg viewBox=\"0 0 80 64\" class=\"gema-op\"><defs><linearGradient id=\"cot_gmz\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#F4F1EC\"/><stop offset=\"1\" stop-color=\"#D9D3C8\"/></linearGradient></defs><polygon points=\"14,22 66,22 40,58\" fill=\"url(#cot_gmz)\" stroke=\"#9A9388\" stroke-width=\"1.2\"/><polygon points=\"14,22 24,8 56,8 66,22\" fill=\"#F4F1EC\" stroke=\"#9A9388\" stroke-width=\"1.2\"/><polyline points=\"24,8 32,22 40,8 48,22 56,8\" fill=\"none\" stroke=\"#9A9388\" stroke-width=\".8\" opacity=\".7\"/><polyline points=\"14,22 40,58 66,22\" fill=\"none\" stroke=\"#9A9388\" stroke-width=\".6\" opacity=\".5\"/></svg>", "moissanita": "<svg viewBox=\"0 0 80 64\" class=\"gema-op\"><defs><linearGradient id=\"cot_gmm\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#FFFFFF\"/><stop offset=\"1\" stop-color=\"#DCE8EE\"/></linearGradient></defs><polygon points=\"14,22 66,22 40,58\" fill=\"url(#cot_gmm)\" stroke=\"#7F8B93\" stroke-width=\"1.2\"/><polygon points=\"14,22 24,8 56,8 66,22\" fill=\"#FFFFFF\" stroke=\"#7F8B93\" stroke-width=\"1.2\"/><polyline points=\"24,8 32,22 40,8 48,22 56,8\" fill=\"none\" stroke=\"#7F8B93\" stroke-width=\".8\" opacity=\".7\"/><polyline points=\"14,22 40,58 66,22\" fill=\"none\" stroke=\"#7F8B93\" stroke-width=\".6\" opacity=\".5\"/><g stroke=\"#7F8B93\" stroke-width=\"1.3\"><line x1=\"40\" y1=\"1\" x2=\"40\" y2=\"6\"/><line x1=\"10\" y1=\"12\" x2=\"14\" y2=\"15\"/><line x1=\"70\" y1=\"12\" x2=\"66\" y2=\"15\"/></g></svg>", "diamante": "<svg viewBox=\"0 0 80 64\" class=\"gema-op\"><defs><linearGradient id=\"cot_gml\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#FFFFFF\"/><stop offset=\"1\" stop-color=\"#E6E4E0\"/></linearGradient></defs><polygon points=\"14,22 66,22 40,58\" fill=\"url(#cot_gml)\" stroke=\"#5A5550\" stroke-width=\"1.2\"/><polygon points=\"14,22 24,8 56,8 66,22\" fill=\"#FFFFFF\" stroke=\"#5A5550\" stroke-width=\"1.2\"/><polyline points=\"24,8 32,22 40,8 48,22 56,8\" fill=\"none\" stroke=\"#5A5550\" stroke-width=\".8\" opacity=\".7\"/><polyline points=\"14,22 40,58 66,22\" fill=\"none\" stroke=\"#5A5550\" stroke-width=\".6\" opacity=\".5\"/><g stroke=\"#5A5550\" stroke-width=\"1.3\"><line x1=\"40\" y1=\"1\" x2=\"40\" y2=\"6\"/><line x1=\"10\" y1=\"12\" x2=\"14\" y2=\"15\"/><line x1=\"70\" y1=\"12\" x2=\"66\" y2=\"15\"/></g></svg>", "natural": "<svg viewBox=\"0 0 80 64\" class=\"gema-op\"><defs><linearGradient id=\"cot_gmn\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#FFFFFF\"/><stop offset=\"1\" stop-color=\"#E6E4E0\"/></linearGradient></defs><polygon points=\"14,22 66,22 40,58\" fill=\"url(#cot_gmn)\" stroke=\"#5A5550\" stroke-width=\"1.2\"/><polygon points=\"14,22 24,8 56,8 66,22\" fill=\"#FFFFFF\" stroke=\"#5A5550\" stroke-width=\"1.2\"/><polyline points=\"24,8 32,22 40,8 48,22 56,8\" fill=\"none\" stroke=\"#5A5550\" stroke-width=\".8\" opacity=\".7\"/><polyline points=\"14,22 40,58 66,22\" fill=\"none\" stroke=\"#5A5550\" stroke-width=\".6\" opacity=\".5\"/><g stroke=\"#5A5550\" stroke-width=\"1.3\"><line x1=\"40\" y1=\"1\" x2=\"40\" y2=\"6\"/><line x1=\"10\" y1=\"12\" x2=\"14\" y2=\"15\"/><line x1=\"70\" y1=\"12\" x2=\"66\" y2=\"15\"/></g></svg>"};
var PASOS = [
  /* foto:"x-" solo enciende la rejilla con miniatura; las claves reales van en img,
     porque no hay una foto por metal sino el mismo anillo en cada uno. */
  { id:"metal", t:"El metal", ayuda:"El kilataje mueve el precio. El color solo cambia la foto.", foto:"metal-",
    ops:[ {v:"oro10",n:"Oro 10k",d:"Amarillo o blanco. Más accesible"},
          {v:"oro14",n:"Oro 14k",d:"Amarillo o blanco. Más puro y más pesado"},
          {v:"plata",n:"Plata .925",d:"Para la pedida o el diario"} ] },
  { id:"material", t:"La piedra", ayuda:"Es la decisión que más mueve el precio.", gema:true,
    ops:[ {v:"diamante",  n:"De laboratorio", d:"Diamante real, con certificado IGI"},
          {v:"moissanita",n:"Moissanita",     d:"Otra piedra, brilla incluso más"},
          {v:"natural",   n:"Natural",        d:"Diamante de mina, con certificado GIA"} ] },
  { id:"forma", t:"La forma", ayuda:"Lo primero que se ve.", foto:"corte-",
    ops:[ {v:"redondo",n:"Redondo",d:"El que más brilla"}, {v:"ovalo",n:"Óvalo",d:"Se ve más grande"},
          {v:"princesa",n:"Princesa",d:"Rinde el presupuesto"}, {v:"esmeralda",n:"Esmeralda",d:"Sobrio"},
          {v:"pera",n:"Pera",d:"Alarga la mano"},
          {v:"cojin",n:"Cojín",d:"Esquinas suaves"}, {v:"marquesa",n:"Marquesa",d:"Puntas, alarga el dedo"},
          {v:"radiante",n:"Radiante",d:"Esquinas cortadas, brilla"} ] },
  /* asscher y corazon: fuera del paso desde el 14 sep (noche) hasta rehacer sus 16 fotos en tres cuartos */
  { id:"quilates", t:"El tamaño", ayuda:"Es peso, no tamaño. Míralo a escala en un dedo real.",
    ops:[ {v:"0.5",n:"0.5 ct",d:"5.1 mm"}, {v:"1",n:"1.0 ct",d:"6.4 mm"},
          {v:"1.5",n:"1.5 ct",d:"7.4 mm"}, {v:"2",n:"2.0 ct",d:"8.1 mm"} ] },
  { id:"engarce", t:"La montura", ayuda:"Cómo se sostiene la piedra.", foto:"eng-",
    ops:[ {v:"garras",n:"Solitario",d:"El clásico"},
          {v:"catedral",n:"Catedral",d:"Con arcos"},
          {v:"halo",n:"Halo",d:"Se ve más grande"},
          {v:"pave",n:"Pavé",d:"Camino de luz"} ] }
];

/* 2 oct: la forma vista desde arriba, para que se distinga en la tarjeta (Jorge: "casi no se ve la forma") */
var FORMA_SVG = {"redondo": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><circle cx=\"20\" cy=\"20\" r=\"15\"/><polygon points=\"20,13 25,15 27,20 25,25 20,27 15,25 13,20 15,15\"/><path d=\"M20 5V13M30.6 9.4L25 15M35 20H27M30.6 30.6L25 25M20 35V27M9.4 30.6L15 25M5 20H13M9.4 9.4L15 15\"/></svg>", "ovalo": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><ellipse cx=\"20\" cy=\"20\" rx=\"11\" ry=\"16\"/><ellipse cx=\"20\" cy=\"20\" rx=\"5.5\" ry=\"8.5\"/><path d=\"M20 4V11.5M20 36V28.5M9 20H14.5M31 20H25.5\"/></svg>", "princesa": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><rect x=\"6\" y=\"6\" width=\"28\" height=\"28\"/><rect x=\"13\" y=\"13\" width=\"14\" height=\"14\"/><path d=\"M6 6L13 13M34 6L27 13M34 34L27 27M6 34L13 27\"/></svg>", "esmeralda": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><polygon points=\"13,4 27,4 32,9 32,31 27,36 13,36 8,31 8,9\"/><polygon points=\"15,9 25,9 27,11 27,29 25,31 15,31 13,29 13,11\"/><path d=\"M13 4L15 9M27 4L25 9M32 9L27 11M32 31L27 29M27 36L25 31M13 36L15 31M8 31L13 29M8 9L13 11\"/></svg>", "pera": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><path d=\"M20 3C27 12 32 19 32 25.5C32 32 26.6 37 20 37C13.4 37 8 32 8 25.5C8 19 13 12 20 3Z\"/><path d=\"M20 14C23.5 19 26 22.5 26 26C26 29.3 23.3 31.5 20 31.5C16.7 31.5 14 29.3 14 26C14 22.5 16.5 19 20 14Z\"/><path d=\"M20 3V14M32 25.5H26M8 25.5H14M20 37V31.5\"/></svg>", "cojin": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><rect x=\"6\" y=\"6\" width=\"28\" height=\"28\" rx=\"8\"/><rect x=\"13\" y=\"13\" width=\"14\" height=\"14\" rx=\"3\"/><path d=\"M8.5 8.5L13.5 13.5M31.5 8.5L26.5 13.5M31.5 31.5L26.5 26.5M8.5 31.5L13.5 26.5\"/></svg>", "marquesa": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><path d=\"M20 2C29.5 11 29.5 29 20 38C10.5 29 10.5 11 20 2Z\"/><path d=\"M20 11C24.5 16 24.5 24 20 29C15.5 24 15.5 16 20 11Z\"/><path d=\"M20 2V11M20 38V29M12.9 20H16.6M27.1 20H23.4\"/></svg>", "radiante": "<svg viewBox=\"0 0 40 40\" width=\"100%\" height=\"100%\" stroke=\"#141413\" stroke-width=\"1.5\" fill=\"none\" stroke-linejoin=\"round\"><polygon points=\"12,4 28,4 32,8 32,32 28,36 12,36 8,32 8,8\"/><polygon points=\"15,10 25,10 26,11 26,29 25,30 15,30 14,29 14,11\"/><path d=\"M12 4L20 10L28 4M12 36L20 30L28 36M8 8L14 20L8 32M32 8L26 20L32 32\"/></svg>"};

/* La gemela en plata: la MISMA pieza (forma, tamano, montura) en plata .925 con
   zirconia. Se calcula con la misma funcion total(), asi que nunca se puede
   despegar del precio de arriba. Si YA elegiste plata arriba, la seccion se
   esconde: ofrecerte la gemela de tu pieza de plata no tiene sentido. */
function selGemela(){ return copia(copia(sel, "material", "zirconia"), "metal", "plata"); }
function pintaGemela(){
  var sec = document.getElementById("gemela-bloque");
  var tit = document.getElementById("gemela-tit");
  var esPlata = (sel.metal === "plata");
  if(sec) sec.style.display = esPlata ? "none" : "";
  if(tit) tit.style.display = esPlata ? "none" : "";
  var caja = document.getElementById("gemela-precio"); if(!caja || esPlata) return;
  var g = total(selGemela());
  var bajo = Math.round(g * 0.92 / 100) * 100, alto = Math.round(g * 1.08 / 100) * 100;
  caja.textContent = pesos(bajo) + " a " + pesos(alto);
  var d = document.getElementById("gemela-det");
  if(d) d.textContent = NOMBRE[sel.forma].charAt(0).toUpperCase() + NOMBRE[sel.forma].slice(1) +
    " de " + ct(sel.quilates) + " ct, montura " + NOMBRE[sel.engarce] + ", en plata .925 con zirconia.";
  var b = document.getElementById("cta-gemela");
  if(b) b.href = WA + "?text=" + encodeURIComponent(
    "Hola, armé mi anillo en la página (" + NOMBRE[sel.forma] + " de " + ct(sel.quilates) + " ct, montura " +
    NOMBRE[sel.engarce] + ", en " + NOMBRE[sel.metal] + ") y lo quiero cotizar junto con su gemela en plata.");
}


function ct(q){ return parseFloat(q).toFixed(1); }
function pesos(n){ return "$" + Math.round(n).toLocaleString("es-MX"); }

function total(s){
  var m = s.material, banda = (s.engarce === "eternity");
  var base = banda ? P.monturaBanda[s.metal] : P.montura[s.metal];
  var montura = base * P.multEngarce[s.engarce];
  if(!banda){ montura *= 1 + P.oroPorQuilate * (parseFloat(s.quilates) - 1); }   /* la cabeza crece con la piedra: poco, pero sube */
  var extras = piedritasDe(s).precio;   /* 19 sep: las piedritas van del mismo material que la central, cobradas por piedra y por mm */
  var centro = 0;
  if(!banda){
    centro = P.central[m][s.quilates] * (m === "diamante" ? 1 : P.multForma[s.forma]);   /* 18 sep: en laboratorio la forma no mueve el precio */
    if(m === "diamante") centro *= P.multCalidad[s.calidad];
    if(s.engarce === "trespiedras") centro *= 1.5;
  }
  return montura + extras + (banda ? 0 : P.engasteCentral) + centro;
}
/* 19 sep: cuántas piedritas lleva la montura, de qué tamaño y a cuánto cada una según la piedra elegida */
function piedritasDe(s){
  var n = P.piedritas[s.engarce] || 0;
  if(!n) return { n:0, mm:0, unit:0, precio:0 };
  var mm = P.mmPiedrita[s.engarce] || 1.5;
  /* 19 sep, Jorge: con central natural, las piedritas van de laboratorio (a precio de laboratorio) y se declara.
     El pavé natural se ofrece en la cita como mejora. */
  var mat = (s.material === "natural") ? "diamante" : s.material;
  var tabla = P.precioPiedrita[mat] || P.precioPiedrita.diamante;
  var unit = tabla[String(mm)] !== undefined ? tabla[String(mm)] : tabla["1.5"];
  return { n:n, mm:mm, unit:unit, precio:n * unit, material:mat, nombre:NOMBRE[mat] };
}
function copia(s, k, v){ var o = {}; for(var i in s) o[i] = s[i]; o[k] = v; return o; }
function aplica(id){ return !(id === "calidad" && sel.material !== "diamante"); }
function esBanda(){ return sel.engarce === "eternity"; }

/* cotizador:movil-14sep */
/* El metal vive como oro10 / oro10b / oro14 / oro14b / plata. El kilataje es
   lo que se elige en la tarjeta; el color (la b) lo pone el interruptor. */
function esBlanco(m){ return m === "plata" || /b$/.test(m); }
function tierDe(m){ return m === "plata" ? "plata" : m.replace(/b$/, ""); }
function metalCon(tier, blanco){ return tier === "plata" ? "plata" : tier + (blanco ? "b" : ""); }
/* la foto que corresponde a lo que lleva armado */
function fotoDe(clave){
  var el = document.querySelector('[data-foto="' + clave + '"]');
  return el ? el.src : "";
}
/* fotos:juego-r */ /* fotos:juego-r3 */ /* fotos:juego-r2 */
/* El juego bueno: r-<montura>_<forma>_<oro|blanco>, 40 fotos, receta del 6 sep
   (anillo completo de frente, aro en escorzo, fondo blanco). Cubre EXACTAMENTE
   las combinaciones que el cotizador pregunta, asi que aqui no hay fallback
   silencioso: si algo faltara, se ve el hueco y se arregla, en vez de mostrar
   una foto que no es la que elegiste. La plata usa la foto de oro blanco. */
/* cotizador:v5 */
/* La foto de UNA opcion: el anillo que llevas armado, con esa sola cosa cambiada.
   Se calcula sobre una copia de sel, asi que nunca puede quedar desfasada de lo
   que muestra el visor, y como el juego `r-` cubre las 40 combinaciones no hay
   forma de pedir una foto que no existe (era el bug de las miniaturas rotas). */
function fotoOpcion(campo, valor){
  var s = copia(sel, campo, valor);
  var met = esBlanco(s.metal) ? "blanco" : "oro";
  return fotoDe("r-" + s.engarce + "_" + s.forma + "_" + met);
}
function fotoActual(){
  var met = esBlanco(sel.metal) ? "blanco" : "oro";
  return fotoDe("r-" + sel.engarce + "_" + sel.forma + "_" + met);
}
function pintaMetal(){
  var im = document.getElementById("previa-img"); if(!im) return;
  var blanco = (sel.metal === "oro10b" || sel.metal === "oro14b" || sel.metal === "plata");
  im.classList.toggle("blanco", false);
}

var pasoActivo = 0;

function pintaPasos(){
  var barra = document.getElementById("pasos-barra");
  var pr = document.getElementById("progreso");
  if(pr) pr.style.width = Math.round((pasoActivo + 1) / PASOS.length * 100) + "%";
  barra.innerHTML = PASOS.map(function(p, i){
    var muerto = !aplica(p.id) || (esBanda() && (p.id === "forma" || p.id === "quilates" || p.id === "calidad"));
    return '<button type="button" role="tab" aria-selected="' + (i === pasoActivo) + '" class="chip' +
      (i === pasoActivo ? " on" : "") + (muerto ? " nulo" : "") +
      '" data-paso="' + i + '"><i>' + (i + 1) + '</i>' + p.t + '</button>';
  }).join("");
}

function pintaPaso(){
  var p = PASOS[pasoActivo];
  var base = total(sel);
  var cuerpo = document.getElementById("paso-cuerpo");
  var nulo = !aplica(p.id) || (esBanda() && (p.id === "forma" || p.id === "quilates" || p.id === "calidad"));
  var aviso = "";
  if(nulo){
    aviso = (p.id === "calidad")
      ? "El color y la claridad solo aplican a los diamantes. Con " + NOMBRE[sel.material] + " este paso te lo saltas."
      : "Una churumbela eternity no lleva piedra central, así que este paso no aplica.";
  }
  cuerpo.innerHTML =
    '<div class="paso-tit"><span class="eyebrow">Paso ' + (pasoActivo + 1) + ' de ' + PASOS.length + '</span><h3>' + p.t + '</h3><p>' + p.ayuda + '</p></div>' +
    (nulo ? '<p class="aviso">' + aviso + '</p>' :
      '<div class="rejop' + ((p.foto || p.gema) ? " con-foto" : "") + '">' + p.ops.map(function(o){
        var ov = (p.id === "metal") ? metalCon(o.v, esBlanco(sel.metal)) : o.v;
        var d = total(copia(sel, p.id, ov)) - base;
        var etiqueta = (Math.abs(d) < 50) ? "Sin cambio" : (d > 0 ? "+" + pesos(d) : "−" + pesos(-d));
        if(sel[p.id] === ov) etiqueta = "Lo que llevas";
        var mini = p.foto ? fotoOpcion(p.id, ov) : "";
        return '<button type="button" class="opc" data-campo="' + p.id + '" data-v="' + ov + '" aria-pressed="' + (sel[p.id] === ov) + '">' +
          (p.gema ? '<span class="op-foto op-gema">' + (GEMA[o.v] || "") + '</span>' :
         mini ? '<span class="op-foto" aria-hidden="true"' + (p.id === "forma" && FORMA_SVG[o.v] ? ' style="position:relative"' : '') + '><img src="' + mini + '" alt="" loading="lazy">' + (p.id === "forma" && FORMA_SVG[o.v] ? '<span class="op-forma" style="position:absolute;left:6px;top:6px;width:38px;height:38px;padding:5px;box-sizing:border-box;background:#fff;border:1px solid #e3e3e3;border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.08)">' + FORMA_SVG[o.v] + '</span>' : '') + '</span>' : "") +
          '<span class="n">' + o.n + '</span><span class="d">' + o.d + '</span><span class="delta">' + etiqueta + '</span></button>';
      }).join("") + '</div>');

  /* el color del oro: mismo precio, otra foto. Con plata se esconde. */
  if(p.id === "metal" && !nulo){
    var col = document.createElement("div"); col.className = "color-oro"; col.id = "color-oro";
    var blancoAhora = esBlanco(sel.metal);
    col.innerHTML = '<span class="co-tit">Color del oro</span>' +
      '<button type="button" class="co" data-color="" aria-pressed="' + !blancoAhora + '">Amarillo</button>' +
      '<button type="button" class="co" data-color="b" aria-pressed="' + blancoAhora + '">Blanco</button>' +
      '<span class="co-nota">Mismo precio. Cambia la foto completa.</span>';
    if(sel.metal === "plata") col.hidden = true;
    var rj = cuerpo.querySelector(".rejop"); if(rj) rj.insertAdjacentElement("afterend", col); else cuerpo.appendChild(col);
  }
  /* el tamano se decide aqui, asi que la piedra a escala se ve aqui */
  if(p.id === "quilates" && !nulo){
    var e = document.createElement("div"); e.className = "escala-real escala-paso";
    var rej = cuerpo.querySelector(".rejop");
    if(rej) cuerpo.insertBefore(e, rej); else cuerpo.appendChild(e);
  }
  /* las miniaturas ya vienen con src desde fotoOpcion(); esto queda por si
     alguna opcion futura vuelve a usar una clave fija */
  cuerpo.querySelectorAll("img[data-src]").forEach(function(im){ im.src = fotoDe(im.dataset.src); });
  try{ pintaEscala(); }catch(e){}   /* la caja se acaba de crear: hay que pintarla ya */
  document.getElementById("btn-atras").style.display = pasoActivo === 0 ? "none" : "";
  document.getElementById("btn-sig").textContent = pasoActivo === PASOS.length - 1 ? "Ver mi resumen" : "Siguiente";
  pintaPasos();
}

function pinta(){
  var banda = esBanda();
  var t = total(sel);
  var caja = document.getElementById("rango"), mens = document.getElementById("mens");
  {
    var hol = (sel.material === "natural") ? 0.15 : P.holgura;
    var natural = (sel.material === "natural");   /* 18 sep: el rango empieza en el precio y sube 12%; natural sigue +/-15% */
    var bajo = Math.round(t * (natural ? 1 - hol : 1) / 100) * 100, alto = Math.round(t * (natural ? 1 + hol : 1.12) / 100) * 100;
    var antes = caja.textContent;
    caja.textContent = pesos(bajo) + " a " + pesos(alto);
    if(antes !== caja.textContent){
      caja.classList.remove("cambia"); void caja.offsetWidth; caja.classList.add("cambia");
    }
    mens.textContent = (sel.material === "natural")
      ? "Aproximado de mina. La piedra exacta se elige contigo, con su certificado GIA enfrente."
      : "Desde " + pesos(bajo / P.msi) + " al mes a " + P.msi + " meses sin intereses";
  }
  var filas = banda
    ? [["Pieza","Churumbela eternity"], ["Piedras", piedritasDe(sel).n + " de " + piedritasDe(sel).nombre + ", " + piedritasDe(sel).mm + " mm"], ["Metal", NOMBRE[sel.metal]]]
    : [["Piedra", NOMBRE[sel.material]], ["Forma", NOMBRE[sel.forma]], ["Tamaño", ct(sel.quilates) + " ct"],
       ["Montura", NOMBRE[sel.engarce]], ["Metal", NOMBRE[sel.metal]]];
  if(!banda && piedritasDe(sel).n) filas.splice(filas.length - 1, 0, ["Piedras chicas", piedritasDe(sel).n + " de " + piedritasDe(sel).nombre + ", " + piedritasDe(sel).mm + " mm"]);
  if(!banda && (sel.material === "diamante" || sel.material === "natural")) filas.splice(3, 0, ["Color y claridad", "Se elige contigo"]);
  document.getElementById("resumen").innerHTML = filas.map(function(f){
    /* mayuscula inicial: el resumen vive junto al precio y en minusculas se leia
       como una nota al pie, no como la ficha de lo que armaste */
    var val = String(f[1]); val = val.charAt(0).toUpperCase() + val.slice(1);
    return "<li><span>" + f[0] + "</span><span>" + val + "</span></li>";
  }).join("");
  var arm = document.getElementById("armado");
  if(arm){
    var mayus = function(s){ return s.charAt(0).toUpperCase() + s.slice(1); };
    arm.innerHTML = banda
      ? "<b>Churumbela eternity</b><br>" + mayus(NOMBRE[sel.material]) + " · " + NOMBRE[sel.metal]
      : "<b>" + mayus(NOMBRE[sel.forma]) + " de " + ct(sel.quilates) + " ct</b><br>Montura " + NOMBRE[sel.engarce] + " · " + NOMBRE[sel.metal];
  }

  var texto = banda
    ? "Hola, armé una churumbela eternity en la página: " + piedritasDe(sel).n + " piedras de " + piedritasDe(sel).nombre + " de " + piedritasDe(sel).mm + " mm en " + NOMBRE[sel.metal] + ". ¿Cuánto me costaría algo así?"
    : "Hola, armé mi anillo en la página: " + NOMBRE[sel.forma] + " de " + ct(sel.quilates) + " ct en " + NOMBRE[sel.material] +
      ((sel.material === "diamante" || sel.material === "natural") ? " (color G-H, claridad VS)" : "") +
      ", montura " + NOMBRE[sel.engarce] + (piedritasDe(sel).n ? " con " + piedritasDe(sel).n + " piedras chicas de " + piedritasDe(sel).nombre : "") + ", en " + NOMBRE[sel.metal] + ". ¿Cuánto me costaría algo así?";
  document.getElementById("cta-wa").href = WA + "?text=" + encodeURIComponent(texto);

  pintaMetal();
  /* la mano no depende de los quilates (Jorge, 6 sep): solo del metal,
     mas la de ovalo porque es la forma que mas cambia puesta en el dedo */
  var man = document.getElementById("previa-mano");
  if(man){
    var blancoM = esBlanco(sel.metal);
    var cl = (sel.forma === "ovalo" && !blancoM) ? "mano-ovalo" : (blancoM ? "mano-blanco" : "mano-oro");
    var f = fotoDe(cl);
    if(f && man.src !== f) man.src = f;
  }
  var im = document.getElementById("previa-img");
  if(im){
    var nueva = fotoActual();
    if(im.src !== nueva){
      im.classList.add("saliendo");
      setTimeout(function(){ im.src = nueva; im.classList.remove("saliendo"); }, 180);
    }
  }
  pintaPaso();
  try{ pintaEscala(); }catch(e){}
  try{ pintaGemela(); }catch(e){}
}

/* nav:avance */
/* Elegir ES avanzar. Antes armar el anillo costaba 10 toques (5 elegir + 5
   Siguiente); ahora son 5. Los 600 ms son el tiempo para ver como cambian la
   foto y el precio antes de pasar: sin esa pausa, el paso se va antes de que
   alcances a ver que hizo tu decision. En el ultimo paso no avanza. */
/* cotizador:sin-auto-avance */
/* Antes, al elegir una opcion el paso se iba solo a los 600 ms. Jorge, 12 sep:
   "deja que jueguen con el, cuando le pico a uno ya me lleva al otro, mejor que
   ellos interactuen". Ahora elegir cambia la foto y el precio y te deja ahi;
   el paso lo mueves tu con Siguiente o con los chips de arriba. */
document.getElementById("paso-cuerpo").addEventListener("click", function(e){
  var c = e.target.closest(".co");
  if(c){ sel.metal = metalCon(tierDe(sel.metal), c.dataset.color === "b"); pinta(); return; }
  var b = e.target.closest(".opc"); if(!b) return;
  sel[b.dataset.campo] = b.dataset.v;
  pinta();
});
document.addEventListener("click", function(e){
  var p = e.target.closest(".piedra-sw .ps"); if(!p) return;
  sel.material = p.dataset.v; pinta();
});
/* En celular el panel es una tira compacta de dos columnas y no cabe el
   interruptor; se clona arriba del primer paso, que es donde se ve. */
(function(){
  function acomodaPiedra(){
    var sw = document.getElementById("piedra-sw");
    var cuerpo = document.getElementById("paso-cuerpo");
    if(!sw || !cuerpo) return;
    var movil = window.innerWidth <= 900;
    var arriba = document.getElementById("piedra-sw-movil");
    if(movil && !arriba){
      arriba = document.createElement("div");
      arriba.className = "piedra-sw"; arriba.id = "piedra-sw-movil";
      cuerpo.parentNode.insertBefore(arriba, cuerpo);
    }
    if(arriba){ arriba.style.display = movil ? "" : "none"; arriba.innerHTML = sw.innerHTML; }
  }
  window.addEventListener("resize", acomodaPiedra);
  var _pinta = pinta;
  pinta = function(){ _pinta(); try{ acomodaPiedra(); }catch(e){} };
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", acomodaPiedra);
  else acomodaPiedra();
})();
document.addEventListener("click", function(e){
  var v = e.target.closest(".vistas-cot .vc"); if(!v) return;
  document.querySelectorAll(".vistas-cot .vc").forEach(function(b){ b.classList.toggle("on", b === v); });
  document.querySelector(".previa").classList.toggle("ver-mano", v.dataset.vista === "mano");
});
/* Las puertas "Continuar" al final de cada vista murieron con el router: en un
   scroll continuo la seccion siguiente ya esta ahi abajo, y un boton para bajar
   a lo que ya se ve es ruido. Se conserva la nota porque explica por que no
   estan, que si no alguien las vuelve a poner. */
document.getElementById("pasos-barra").addEventListener("click", function(e){
  var b = e.target.closest(".chip"); if(!b) return;
  pasoActivo = +b.dataset.paso; pintaPaso(); subeAlPaso();
});
/* En celular, al cambiar de paso el nuevo titulo queda debajo del panel pegado
   si no se sube: era el "se pierde un poco" de Jorge. */
function subeAlPaso(){
  var c = document.getElementById("paso-cuerpo");
  if(c && window.innerWidth <= 900){
    var y = c.getBoundingClientRect().top + window.scrollY - (document.querySelector(".cot .panel").offsetHeight + 72);
    window.scrollTo({ top:Math.max(y, 0), behavior:"smooth" });
  }
}
document.getElementById("btn-atras").addEventListener("click", function(){
  if(pasoActivo > 0){ pasoActivo--; pintaPaso(); }
});
document.getElementById("btn-sig").addEventListener("click", function(){
  if(pasoActivo < PASOS.length - 1){
    pasoActivo++; pintaPaso(); subeAlPaso();
  } else {
    var fin = document.querySelector(".cierre-cot") || document.querySelector(".panel");
    fin.scrollIntoView({ behavior:"smooth", block:"center" });
  }
});

/* en celular el resumen, las facilidades y el CTA viven al final del flujo,
   para que lo pegado arriba sea solo el anillo y el precio */
(function(){
  var chico = window.matchMedia("(max-width:900px)");
  var caja = null;
  function acomoda(){
    var panel = document.querySelector(".cot .panel"), nav = document.querySelector(".navpasos");
    if(!panel || !nav) return;
    var piezas = [document.getElementById("resumen"), panel.querySelector(".facil"),
                  document.getElementById("cta-wa"), panel.querySelector(".nota")];
    if(chico.matches){
      if(!caja){
        caja = document.createElement("div");
        caja.className = "cierre-cot";
        nav.parentNode.insertBefore(caja, nav);
      }
      piezas.forEach(function(p){ if(p) caja.appendChild(p); });
    } else if(caja){
      piezas.forEach(function(p){ if(p) panel.insertBefore(p, null); });
      caja.remove(); caja = null;
    }
  }
  acomoda();
  if(chico.addEventListener) chico.addEventListener("change", acomoda);
})();

/* ---- CTAs de cita ---- */
(function(){
  var cita = WA + "?text=" + encodeURIComponent("Hola, quiero agendar una cita para ver anillos de compromiso.");
  var video = WA + "?text=" + encodeURIComponent("Hola, quiero agendar una videollamada para ver anillos de compromiso.");
  var c1 = document.getElementById("cta-cita1"), c2 = document.getElementById("cta-cita2"), c3 = document.getElementById("cta-cierre");
  var c4 = document.getElementById("wa-barra");
  if(c1) c1.href = cita; if(c2) c2.href = video; if(c3) c3.href = cita; if(c4) c4.href = cita;
  /* 24 sep 2026: los botones de cita llevan a la agenda (Calendly); WhatsApp se queda en la barra */
  var AGENDA = "https://calendly.com/dajodesignswk/cita-lumbre";
  ["cta-hero", "cta-cita1", "cta-cita2", "cta-cierre"].forEach(function(id){
    var a = document.getElementById(id); if(a) a.href = AGENDA;
  });
})();

/* ---- navegacion: scroll continuo con resaltado por posicion ---- */
/* El router murio. El menu ahora lleva a la seccion con scroll suave, y la liga
   activa se decide por DONDE ESTAS, no por lo que tocaste: es lo que hace que
   una pagina larga no se sienta perdida. */
var VISTAS = ["inicio","cotizador","aprende","cita","churumbelas"];
function abre(id, empuja){
  var el = document.getElementById("v-" + id);
  if(!el) return;
  el.scrollIntoView({ behavior: empuja ? "smooth" : "auto", block:"start" });
  if(empuja && location.hash !== "#" + id){ history.replaceState(null, "", "#" + id); }
}
document.addEventListener("click", function(e){
  var a = e.target.closest('a[href^="#"]'); if(!a) return;
  var id = a.getAttribute("href").slice(1);
  if(VISTAS.indexOf(id) === -1) return;
  e.preventDefault(); abre(id, true);
  var barra = document.querySelector(".barra");
  if(barra) barra.classList.remove("abierta");
});
(function(){
  /* Que liga del menu va marcada: la seccion que ocupa el CENTRO de la pantalla.
     Antes se hacia con IntersectionObserver y una franja del 45% al 50%, o sea
     45 px en escritorio: si el scroll saltaba esa franja el observer no se
     enteraba y el menu se quedaba marcando la seccion anterior. Medido: en el
     cotizador marcaba "Empieza aqui" y en aprender marcaba "Arma el tuyo".
     Calcularlo directo no tiene ese agujero. */
  var VIS = VISTAS.map(function(v){ return { id:v, el:document.getElementById("v-" + v) }; })
                  .filter(function(x){ return x.el; });
  var ligas = [].slice.call(document.querySelectorAll("#nav a"));
  var pendiente = false;
  function marca(){
    pendiente = false;
    /* La seccion marcada es la que MAS ocupa la pantalla, no la que cruza una
       linea imaginaria. Con la linea, un titulo alto bastaba para que el menu
       siguiera marcando la seccion anterior aunque el cotizador llenara la
       vista (medido en escritorio: v-cotizador empezaba a 513 px y la linea del
       42% caia en 378, o sea todavia dentro del inicio). Cuanta pantalla ocupa
       cada una es lo mismo que ve el ojo. */
    var vp = window.innerHeight, mejor = 0, activa = VIS[0].id;
    for(var i = 0; i < VIS.length; i++){
      var r = VIS[i].el.getBoundingClientRect();
      var visible = Math.min(r.bottom, vp) - Math.max(r.top, 64);
      if(visible > mejor){ mejor = visible; activa = VIS[i].id; }
    }
    ligas.forEach(function(a){ a.classList.toggle("on", a.getAttribute("href") === "#" + activa); });
  }
  function pide(){ if(!pendiente){ pendiente = true; requestAnimationFrame(marca); } }
  window.addEventListener("scroll", pide, { passive:true });
  window.addEventListener("resize", pide);
  marca();

  /* La barra fija de Atras/Siguiente solo existe mientras tienes el paso
     ENFRENTE. Observando la seccion entera se quedaba pegada abajo dos
     pantallas despues, porque el cotizador mide 2,500 px. */
  var cot = document.getElementById("paso-cuerpo");
  if(cot && "IntersectionObserver" in window) new IntersectionObserver(function(e){
    document.body.classList.toggle("en-cotizador", e[0].isIntersecting);
  }, { threshold:0 }).observe(cot);
})();


/* ---- reveal ---- */
function revela(){
  var lim = window.innerHeight * 0.94;
  document.querySelectorAll(".rv:not(.in), .escala:not(.in)").forEach(function(el){
    if(el.getBoundingClientRect().top < lim) el.classList.add("in");
  });
}
window.addEventListener("scroll", revela, { passive:true });
window.addEventListener("resize", revela);

/* ---- parallax suave del hero ---- */
(function(){
  var foto = document.querySelector(".hero-foto");
  var quieto = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if(!foto || quieto) return;
  var tic = false;
  window.addEventListener("scroll", function(){
    if(tic) return; tic = true;
    requestAnimationFrame(function(){
      var y = Math.min(window.scrollY, 600);
      foto.style.transform = "translateY(" + (y * -0.06) + "px)";
      tic = false;
    });
  }, { passive:true });
})();

/* ---- los videos solo corren cuando se ven ---- */
(function(){
  if(!("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function(filas){
    filas.forEach(function(f){
      var v = f.target;
      if(f.isIntersecting){ var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
      else v.pause();
    });
  }, { threshold:0.15 });
  document.querySelectorAll("video").forEach(function(v){ io.observe(v); });
})();


/* ---- escala real: forma + quilates sobre un dedo de 17 mm ---- */
var MM1CT = { redondo:[6.4,6.4], ovalo:[7.7,5.7], princesa:[5.5,5.5], esmeralda:[7.0,5.0], cojin:[5.8,5.8], pera:[8.0,5.5],
              marquesa:[10.0,5.0], radiante:[6.5,5.5], asscher:[5.5,5.5], corazon:[6.5,6.5], baguette:[7.0,4.0] };
function formaPath(f, L, W){  /* centrado en 0,0 ; L = largo (eje x), W = ancho (eje y) en unidades svg */
  var l = L/2, w = W/2;
  switch(f){
    case "redondo": return '<circle cx="0" cy="0" r="'+l+'"/>';
    case "ovalo":   return '<ellipse cx="0" cy="0" rx="'+l+'" ry="'+w+'"/>';
    case "princesa":return '<rect x="'+(-l)+'" y="'+(-w)+'" width="'+L+'" height="'+W+'" rx="0.4"/>';
    case "cojin":   return '<rect x="'+(-l)+'" y="'+(-w)+'" width="'+L+'" height="'+W+'" rx="'+(l*0.42)+'"/>';
    case "baguette":return '<rect x="'+(-l)+'" y="'+(-w)+'" width="'+L+'" height="'+W+'" rx="0.3"/>';
    case "esmeralda": case "radiante": case "asscher": {
      var c = Math.min(l,w)*0.28;
      return '<polygon points="'+(-l+c)+','+(-w)+' '+(l-c)+','+(-w)+' '+l+','+(-w+c)+' '+l+','+(w-c)+' '+(l-c)+','+w+' '+(-l+c)+','+w+' '+(-l)+','+(w-c)+' '+(-l)+','+(-w+c)+'"/>';
    }
    case "pera":    return '<path d="M '+(-l)+' 0 C '+(-l)+' '+(-w*1.1)+', '+(l*0.15)+' '+(-w*1.15)+', '+(l*0.55)+' '+(-w*0.55)+' L '+l+' 0 L '+(l*0.55)+' '+(w*0.55)+' C '+(l*0.15)+' '+(w*1.15)+', '+(-l)+' '+(w*1.1)+', '+(-l)+' 0 Z"/>';
    case "marquesa":return '<path d="M '+(-l)+' 0 C '+(-l*0.5)+' '+(-w*1.35)+', '+(l*0.5)+' '+(-w*1.35)+', '+l+' 0 C '+(l*0.5)+' '+(w*1.35)+', '+(-l*0.5)+' '+(w*1.35)+', '+(-l)+' 0 Z"/>';
    case "corazon": return '<path d="M 0 '+(w*0.95)+' C '+(-l*1.15)+' '+(w*0.1)+', '+(-l*0.75)+' '+(-w*1.05)+', 0 '+(-w*0.35)+' C '+(l*0.75)+' '+(-w*1.05)+', '+(l*1.15)+' '+(w*0.1)+', 0 '+(w*0.95)+' Z"/>';
  }
  return '<circle cx="0" cy="0" r="'+l+'"/>';
}
var escalaFormaAnterior = "";
function pintaEscala(){
  /* pinta en TODAS las cajas .escala-real: la del panel (escritorio) y la que
     vive dentro del paso del tamano (celular). Antes solo pintaba una y en
     celular esa estaba con display:none, o sea invisible para el 91% de la gente. */
  var cajas = document.querySelectorAll(".escala-real");
  for(var ci = 0; ci < cajas.length; ci++){ unaEscala(cajas[ci]); }
}
function unaEscala(caja){
  if(!caja) return;
  if(esBanda()){ caja.style.display = "none"; return; }
  caja.style.display = "";
  var d = MM1CT[sel.forma] || MM1CT.redondo, k = Math.pow(parseFloat(sel.quilates), 1/3);
  var L = d[0]*k, W = d[1]*k;                       /* mm reales */
  var PX = 4.6;                                     /* unidades svg por mm ; dedo de 17 mm = 78 */
  var base = formaPath(sel.forma, d[0]*PX, d[1]*PX);/* dibujada a 1 ct, se escala con transform */
  if(!caja.firstChild || caja.dataset.forma !== sel.forma){
    caja.innerHTML =
      '<svg viewBox="0 0 120 60" role="img" aria-label="Tamaño real aproximado de la piedra">' +
      '<rect x="21" y="6" width="78" height="48" rx="24" fill="var(--marco)"/>' +
      '<rect x="21" y="26" width="78" height="7" fill="none" stroke="var(--realce)" stroke-width="1.2"/>' +
      '<g class="piedra-g"><g transform="translate(60,30)" fill="var(--fondo)" stroke="var(--texto)" stroke-width="1.1">'+base+'</g></g>' +
      '</svg><div class="er-cap"><span>A escala, en un dedo de 17 mm</span><b class="er-mm"></b></div>';
    caja.dataset.forma = sel.forma;
  }
  var g = caja.querySelector(".piedra-g");
  if(g) g.style.transform = "scale(" + k.toFixed(3) + ")";
  var mm = caja.querySelector(".er-mm");
  if(mm) mm.textContent = ct(sel.quilates) + " ct · " + L.toFixed(1) + " × " + W.toFixed(1) + " mm";
}

/* ---- menu movil ---- */
(function(){
  var barra = document.querySelector(".barra"), btn = document.getElementById("menu-btn");
  if(!barra || !btn) return;
  btn.addEventListener("click", function(){
    var ab = barra.classList.toggle("abierta"); btn.setAttribute("aria-expanded", ab ? "true" : "false");
  });
  document.querySelectorAll("#nav a").forEach(function(a){
    a.addEventListener("click", function(){ barra.classList.remove("abierta"); btn.setAttribute("aria-expanded","false"); });
  });
})();

/* ---- iconos de las formas (misma geometria que la escala real) ---- */
/* formas:facetas */
/* Radio del contorno en un angulo. Exacto en las de elipse y en las de caja;
   en pera, marquesa y corazon es una aproximacion, y por eso ahi no se dibujan
   los radios que llegan al borde. */
function radioForma(f, th, l, w){
  var c = Math.cos(th), s2 = Math.sin(th);
  if (f === "princesa" || f === "baguette" || f === "cojin" ||
      f === "esmeralda" || f === "radiante" || f === "asscher"){
    var a = Math.abs(c) < 1e-6 ? 1e6 : l / Math.abs(c);
    var b = Math.abs(s2) < 1e-6 ? 1e6 : w / Math.abs(s2);
    return Math.min(a, b);
  }
  return 1 / Math.sqrt((c*c)/(l*l) + (s2*s2)/(w*w));
}
function facetasForma(f, L, W){
  var l = L/2, w = W/2, g = '<g class="fac">', i, th, r1, r2, k;
  g += formaPath(f, L*0.50, W*0.50);   /* la mesa */
  g += formaPath(f, L*0.80, W*0.80);   /* la cintura */
  for (i = 0; i < 8; i++){
    th = (22.5 + i*45) * Math.PI/180;
    r1 = radioForma(f, th, l*0.50, w*0.50);
    r2 = radioForma(f, th, l*0.80, w*0.80);
    g += '<line x1="'+(Math.cos(th)*r1).toFixed(2)+'" y1="'+(Math.sin(th)*r1).toFixed(2)+
         '" x2="'+(Math.cos(th)*r2).toFixed(2)+'" y2="'+(Math.sin(th)*r2).toFixed(2)+'"/>';
  }
  if (f !== "pera" && f !== "marquesa" && f !== "corazon"){
    k = (f === "cojin" || f === "esmeralda" || f === "radiante" || f === "asscher") ? 0.90 : 0.97;
    for (i = 0; i < 4; i++){
      th = (i*90) * Math.PI/180;
      r1 = radioForma(f, th, l*0.80, w*0.80);
      r2 = radioForma(f, th, l, w) * k;
      g += '<line x1="'+(Math.cos(th)*r1).toFixed(2)+'" y1="'+(Math.sin(th)*r1).toFixed(2)+
           '" x2="'+(Math.cos(th)*r2).toFixed(2)+'" y2="'+(Math.sin(th)*r2).toFixed(2)+'"/>';
    }
  }
  return g + '</g>';
}
document.querySelectorAll('.formas-tira svg[data-forma]').forEach(function(sv){
  var f = sv.getAttribute('data-forma'), d = MM1CT[f] || MM1CT.redondo, k = 14 / Math.max(d[0], d[1]);
  sv.innerHTML = formaPath(f, d[0]*k, d[1]*k) + facetasForma(f, d[0]*k, d[1]*k);
});


/* ---- autoplay en celular: iOS/Android a veces bloquean el autoplay (ahorro de energia, navegador dentro de apps)
       y muestran el boton de play; al primer toque o scroll se destraban todos los videos ---- */
(function(){
  function arranca(){ document.querySelectorAll("video:not([data-dajo-vista]), video[data-dajo-visto]").forEach(function(v){ v.muted = true; v.setAttribute("muted",""); v.setAttribute("playsinline",""); v.setAttribute("webkit-playsinline",""); var p = v.play(); if(p && p.catch) p.catch(function(){}); }); }
  if (document.readyState === "complete") arranca(); else window.addEventListener("load", arranca);
  ["touchstart","touchend","click","scroll","keydown"].forEach(function(e){ window.addEventListener(e, arranca, {once:true, passive:true}); });
})();

/* ---- arranque ---- */
(function(){
 try{
  if(location.hash) abre(location.hash.slice(1), false);
  pinta();
  setTimeout(revela, 60);
  try{ pintaEscala(); }catch(e){}
  setTimeout(revela, 600);
 }catch(e){ try{ pinta(); }catch(e2){} }
})();

;

/* Pista de puntos para los rieles de celular. Se genera sola a partir de las
   tarjetas que ya existen, asi que un riel nuevo la hereda sin tocar nada. */
(function(){
  function pon(){
    if (window.innerWidth > 900) return;
    document.querySelectorAll('.rej').forEach(function(r){
      if (r.dataset.pista) return;
      if (r.scrollWidth <= r.clientWidth + 4) return;
      var n = r.children.length;
      if (n < 2) return;
      var p = document.createElement('div');
      p.className = 'pista';
      for (var i = 0; i < n; i++) p.appendChild(document.createElement('i'));
      p.children[0].className = 'on';
      r.insertAdjacentElement('afterend', p);
      r.dataset.pista = '1';
      r.addEventListener('scroll', function(){
        var i = Math.round(r.scrollLeft / (r.scrollWidth / n));
        if (i > n - 1) i = n - 1;
        for (var k = 0; k < n; k++) p.children[k].className = (k === i ? 'on' : '');
      }, {passive:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pon);
  else pon();
  window.addEventListener('resize', pon);
})();

;

/* barra:no-repite-hero */
/* Mientras el hero esta en pantalla, su boton YA dice "arma el tuyo": la barra
   fija de abajo repetiria el mismo CTA. Se esconde ahi y reaparece al bajar. */
(function(){
  var barra = document.querySelector('.arma-fija');
  var hero  = document.querySelector('.hero .ctas');
  if(!barra || !hero || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(e){
    barra.style.visibility = e[0].isIntersecting ? 'hidden' : '';
  }, {threshold:0}).observe(hero);
})();

;

/* nav:abre-acordeon */
/* Un enlace que apunta a un acordeon CERRADO te deja mirando un titulo: se ve
   roto aunque el ancla funcione. Estos lo abren y luego bajan. */
document.addEventListener("click", function(e){
  var a = e.target.closest('a[href^="#ap-"]'); if(!a) return;
  var d = document.getElementById(a.getAttribute("href").slice(1));
  if(!d) return;
  e.preventDefault();
  d.open = true;
  d.scrollIntoView({ behavior:"smooth", block:"start" });
  history.replaceState(null, "", a.getAttribute("href"));
});

;

/* datos:una-sola-fuente */
/* Las tarjetas de "La piedra" traian el precio de 1 ct escrito a mano y se
   habian despegado del cotizador: decian $65,000 para el natural cuando el
   modelo cobra $85,000, y "de 4 a 5 veces el de laboratorio" cuando la razon
   real es casi siete. Ahora los tres numeros y la comparacion SALEN DEL OBJETO
   P, que es el mismo que cotiza. Si Jorge cambia un precio, la pagina entera
   se mueve con el. */
(function(){
  if(typeof P === "undefined") return;
  function pes(n){ return "$" + Math.round(n/500)*500; }
  var lab = P.central.diamante["1"], nat = P.central.natural["1"], moi = P.central.moissanita["1"];
  var mapa = {
    "Diamante de laboratorio": pes(lab).replace(/(\d)(?=(\d{3})+$)/g, "$1,") + " aprox.",
    "Diamante natural":        pes(nat).replace(/(\d)(?=(\d{3})+$)/g, "$1,") + " aprox.",
    "Moissanita":              "Miles",
    "Zirconia":                "Cientos"
  };
  document.querySelectorAll(".card.tp").forEach(function(c){
    var nom = (c.querySelector("h3") || {}).textContent;
    var fila = [].slice.call(c.querySelectorAll(".tp-datos li")).filter(function(li){
      return (li.querySelector("span") || {}).textContent === "1 ct"; })[0];
    if(fila && mapa[nom]) fila.querySelector("b").textContent = mapa[nom];
    /* y la comparacion contra el de laboratorio, calculada */
    if(nom === "Diamante natural"){
      var lede = c.querySelector(".lede");
      if(lede) lede.textContent = "Diamante real, formado bajo tierra. Unas " +
        Math.round(nat/lab) + " veces el precio del de laboratorio.";
    }
  });
})();

;
/* dajo-vel-18sep: videos fuera del hero arrancan solo cuando se ven */
(function(){var vs=document.querySelectorAll('video[data-dajo-vista]');if(!vs.length)return;
function go(v){var p=v.play();if(p&&p.catch)p.catch(function(){});}
if(!('IntersectionObserver' in window)){vs.forEach(go);return;}
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.setAttribute('data-dajo-visto','');go(e.target);}else{e.target.removeAttribute('data-dajo-visto');if(!e.target.paused)e.target.pause();}});},{threshold:0.25});
vs.forEach(function(v){io.observe(v);});})();